<span>{{ 'AITopic::InferenceCompletedNotificationMessage' | abpLocalization }}</span>
